module.exports = __webpack_public_path__ + "static/media/background_fw_genexis_mx.bcf14878.png";